// extracted by mini-css-extract-plugin
export default {"content":"simpleDialog_content__EyhPs","footer":"simpleDialog_footer__47XaN"};